'use strict';

import React,{ Component} from 'react';
import CurrencyFormat from 'react-currency-format';
import { Grid, Card, Box } from '@material-ui/core';
import { cyan } from '@material-ui/core/colors';

class microChart extends Component{
    render() {
        var variable = "mini-charts-item bgm-cyan";
        if (this.props.color != null) {
            variable = "mini-charts-item " + this.props.color;
        }
        // console.log('[DEBUG],microChart, Value, ',this.props.Value);
        return (
            <Grid item md={3} sm={6}>
                <Card color={cyan}>
                    <div className={variable}>
                    <Box p={1}>
                        <div className="chart stats-bar"></div>
                        <div className="count">
                            <small>{this.props.graphName}</small>
                            <h2>
                                <CurrencyFormat 
                                    value={this.props.Value} 
                                    displayType={'text'} 
                                    thousandSeparator={" "} 
                                    suffix={" "+this.props.unit}
                                />
                            </h2>
                        </div>
                    </Box>
                    </div>
                </Card>
            </Grid>
        )
    }
};
export default microChart
